// One-click overlay templates. Each builder returns a fresh element array.
import { t } from "../i18n";
const uid = () => crypto.randomUUID();

function txt(o) {
  return {
    id: uid(),
    tipo: "texto",
    nome: o.nome || t("Texto"),
    grupo: o.grupo,
    x: o.x, y: o.y, largura: o.largura, altura: o.altura,
    rotacao: 0, zIndex: o.zIndex, opacidade: 100, visivel: true, travado: false,
    conteudo: o.conteudo ?? "",
    blendMode: "normal",
    estilo: {
      fontFamily: o.fontFamily || "Manrope",
      fontSize: o.fontSize || 48,
      color: o.color || "#ffffff",
      fontWeight: o.fontWeight || 800,
      textAlign: o.textAlign || "left",
      verticalAlign: o.verticalAlign || "middle",
      lineHeight: 1.1,
      letterSpacing: o.letterSpacing || 0,
      strokeWidth: 0, strokeColor: "#000000",
      shadowX: 0, shadowY: 2, shadowBlur: o.shadowBlur ?? 6, shadowColor: "rgba(0,0,0,0.6)",
      bgColor: o.bgColor || "#000000",
      bgOpacity: o.bgOpacity ?? 0,
      padding: o.padding ?? 0,
      borderRadius: o.borderRadius ?? 0,
    },
    animacao: {
      entrada: { efeito: o.entrada || "fade", direcao: o.direcao || "up", duracao: o.duracao || 500, delay: o.delay || 0 },
      saida: { efeito: o.saidaEfeito || "fade", direcao: o.saidaDirecao || o.direcao || "down", duracao: o.saidaDuracao || 400 },
    },
    papel: o.papel,
    timer: o.timer,
  };
}

function lowerThird() {
  const G = "Lower Third";
  return [
    txt({ nome: t("Painel"), grupo: G, x: 80, y: 820, largura: 820, altura: 150, bgColor: "#0a0a0c", bgOpacity: 88, borderRadius: 10, entrada: "slide", direcao: "left" }),
    txt({ nome: t("Faixa"), grupo: G, x: 80, y: 820, largura: 12, altura: 150, bgColor: "#007AFF", bgOpacity: 100, entrada: "slide", direcao: "left", delay: 60 }),
    txt({ nome: t("Título"), grupo: G, conteudo: t("NOME DO CONVIDADO"), x: 120, y: 838, largura: 760, altura: 62, fontSize: 50, fontWeight: 800, entrada: "slide", direcao: "up", delay: 120 }),
    txt({ nome: t("Subtítulo"), grupo: G, conteudo: t("Cargo • Descrição"), x: 120, y: 906, largura: 760, altura: 48, fontSize: 28, fontWeight: 600, color: "#7fb0ff", entrada: "slide", direcao: "up", delay: 180 }),
  ].map((e, i) => ({ ...e, zIndex: i }));
}

function scoreboard() {
  const G = t("Placar");
  return [
    txt({ nome: t("Painel"), grupo: G, x: 660, y: 48, largura: 600, altura: 112, bgColor: "#0a0a0c", bgOpacity: 92, borderRadius: 14, entrada: "slide", direcao: "down" }),
    txt({ nome: t("Time Casa"), grupo: G, conteudo: t("CASA"), x: 680, y: 62, largura: 180, altura: 34, fontSize: 26, fontWeight: 700, textAlign: "center" }),
    txt({ nome: t("Time Fora"), grupo: G, conteudo: t("FORA"), x: 1060, y: 62, largura: 180, altura: 34, fontSize: 26, fontWeight: 700, textAlign: "center" }),
    txt({ nome: t("Placar Casa"), grupo: G, conteudo: "0", papel: "placar", x: 700, y: 92, largura: 140, altura: 60, fontSize: 52, fontWeight: 800, color: "#007AFF", textAlign: "center" }),
    txt({ nome: t("Placar Fora"), grupo: G, conteudo: "0", papel: "placar", x: 1080, y: 92, largura: 140, altura: 60, fontSize: 52, fontWeight: 800, color: "#007AFF", textAlign: "center" }),
    txt({ nome: t("Tempo"), grupo: G, conteudo: "00:00", papel: "cronometro", timer: { duration: 600, remaining: 600, running: false, startedAt: null }, x: 880, y: 70, largura: 160, altura: 72, fontSize: 40, fontWeight: 700, textAlign: "center", fontFamily: "JetBrains Mono" }),
  ].map((e, i) => ({ ...e, zIndex: i }));
}

function countdown() {
  const G = t("Cronômetro");
  return [
    txt({ nome: t("Painel"), grupo: G, x: 720, y: 420, largura: 480, altura: 200, bgColor: "#0a0a0c", bgOpacity: 82, borderRadius: 20, entrada: "scale" }),
    txt({ nome: t("Rótulo"), grupo: G, conteudo: t("COMEÇA EM"), x: 720, y: 440, largura: 480, altura: 42, fontSize: 26, fontWeight: 700, letterSpacing: 4, color: "#7fb0ff", textAlign: "center", entrada: "fade", delay: 100 }),
    txt({ nome: t("Tempo"), grupo: G, conteudo: "05:00", papel: "cronometro", timer: { duration: 300, remaining: 300, running: false, startedAt: null }, x: 720, y: 482, largura: 480, altura: 120, fontSize: 104, fontWeight: 800, textAlign: "center", fontFamily: "JetBrains Mono", entrada: "fade", delay: 160 }),
  ].map((e, i) => ({ ...e, zIndex: i }));
}

function dyn(o) {
  return {
    id: uid(),
    tipo: "dynamic",
    nome: o.nome || t("Dado YouTube"),
    grupo: o.grupo,
    metrica: o.metrica || "viewers",
    formato: o.formato || "abbrev",
    modo: o.modo || "texto",
    template: o.template ?? "{n}",
    meta: o.meta || 1000,
    x: o.x, y: o.y, largura: o.largura, altura: o.altura,
    rotacao: 0, zIndex: o.zIndex, opacidade: 100, visivel: true, travado: false,
    blendMode: "normal",
    estilo: {
      fontFamily: o.fontFamily || "Manrope", fontSize: o.fontSize || 48, color: o.color || "#ffffff",
      fontWeight: o.fontWeight || 800, textAlign: o.textAlign || "left", verticalAlign: "middle",
      lineHeight: 1.1, letterSpacing: 0, strokeWidth: 0, strokeColor: "#000000",
      shadowX: 0, shadowY: 2, shadowBlur: 6, shadowColor: "rgba(0,0,0,0.6)",
      bgColor: "#000000", bgOpacity: 0, padding: 0, borderRadius: 0,
      barColor: o.barColor || "#007AFF", barBg: o.barBg || "#1a1a20",
    },
    animacao: {
      entrada: { efeito: o.entrada || "fade", direcao: o.direcao || "up", duracao: o.duracao || 500, delay: o.delay || 0 },
      saida: { efeito: o.saidaEfeito || "fade", direcao: o.saidaDirecao || o.direcao || "down", duracao: o.saidaDuracao || 400 },
    },
  };
}

function ytSubGoal() {
  const G = t("Meta Inscritos");
  return [
    txt({ nome: t("Painel"), grupo: G, x: 80, y: 892, largura: 560, altura: 120, bgColor: "#0a0a0c", bgOpacity: 88, borderRadius: 16, entrada: "slide", direcao: "left" }),
    txt({ nome: t("Rótulo"), grupo: G, conteudo: t("META DE INSCRITOS"), x: 104, y: 906, largura: 512, altura: 30, fontSize: 20, fontWeight: 700, letterSpacing: 3, color: "#7fb0ff", entrada: "slide", direcao: "left", delay: 80 }),
    dyn({ nome: t("Meta de Inscritos"), grupo: G, metrica: "subscribers", modo: "barra", meta: 1000, template: "{n}", x: 104, y: 936, largura: 512, altura: 60, fontSize: 30, formato: "abbrev", entrada: "slide", direcao: "left", delay: 140 }),
  ].map((e, i) => ({ ...e, zIndex: i }));
}

function ytViewers() {
  const G = t("Espectadores");
  return [
    txt({ nome: t("Pílula"), grupo: G, x: 1548, y: 56, largura: 312, altura: 72, bgColor: "#cc0000", bgOpacity: 92, borderRadius: 999, entrada: "fade" }),
    dyn({ nome: t("Espectadores ao Vivo"), grupo: G, metrica: "viewers", modo: "texto", template: "👁 {n}", x: 1568, y: 70, largura: 272, altura: 44, fontSize: 34, textAlign: "center", formato: "abbrev", entrada: "fade", delay: 60 }),
  ].map((e, i) => ({ ...e, zIndex: i }));
}

export const TEMPLATES = [
  { key: "lower", nome: "Lower Third", desc: t("Nome + cargo do convidado"), build: lowerThird },
  { key: "score", nome: t("Placar"), desc: t("Casa x Fora com tempo"), build: scoreboard },
  { key: "timer", nome: t("Cronômetro"), desc: t("Contagem regressiva de abertura"), build: countdown },
  { key: "ytsubs", nome: t("Meta de Inscritos"), desc: t("Barra de progresso de inscritos (YouTube)"), build: ytSubGoal },
  { key: "ytviewers", nome: t("Espectadores ao Vivo"), desc: t("Contador de audiência em tempo real"), build: ytViewers },
];
